import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body px-0 pt-0 pb-2" }
const _hoisted_3 = { class: "table-responsive p-0" }
const _hoisted_4 = {
  key: 0,
  class: "p-5 pe-md-3 d-flex align-items-center ms-md-auto"
}
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text text-body" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-search",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_7 = { class: "table align-items-center mb-0" }
const _hoisted_8 = { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_9 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Operação ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", { class: "text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" }, "Status", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "text-secondary opacity-7" }, null, -1)
const _hoisted_13 = { class: "align-middle text-center" }
const _hoisted_14 = { class: "text-secondary text-xs font-weight-bold" }
const _hoisted_15 = { class: "d-flex px-2 py-1" }
const _hoisted_16 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_17 = { class: "mb-0 text-sm" }
const _hoisted_18 = { class: "text-xs text-secondary mb-0" }
const _hoisted_19 = { class: "align-middle text-center text-sm" }
const _hoisted_20 = { class: "form-check form-switch" }
const _hoisted_21 = ["onChange", "onUpdate:modelValue"]
const _hoisted_22 = {
  class: "form-check-label",
  for: "flexSwitchCheckDefault"
}
const _hoisted_23 = { class: "text-sm" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-user-edit text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-trash text-secondary",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_29 = [
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.searchItem)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.searchCall(_ctx.searchIKey,_ctx.searchQuery)), ["enter"])),
                  placeholder: "Procurar..."
                }, null, 544), [
                  [_vModelText, _ctx.searchQuery]
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_8, [
                _createElementVNode("i", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchData('id_operacao'))),
                  class: "fas fa-search"
                })
              ]),
              _createElementVNode("th", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("i", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchData('name'))),
                  class: "fas fa-search"
                })
              ]),
              _hoisted_11,
              _hoisted_12
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (produto) => {
              return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(produto.id_operacao), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("h6", _hoisted_17, _toDisplayString(produto.name), 1),
                      _createElementVNode("p", _hoisted_18, _toDisplayString(produto.brand), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      id: "flexSwitchCheckDefault",
                      onChange: ($event: any) => (_ctx.salvarUnico(produto)),
                      "onUpdate:modelValue": ($event: any) => ((produto.ativo) = $event)
                    }, null, 40, _hoisted_21), [
                      [_vModelCheckbox, produto.ativo]
                    ]),
                    _createElementVNode("label", _hoisted_22, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge badge-sm", {'bg-success': produto.ativo, 'bg-danger': !produto.ativo}])
                      }, _toDisplayString(produto.ativo ? 'Ativo' : 'Inativo'), 3)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_23, [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: ($event: any) => (_ctx.getUnico(produto.id)),
                    class: "mx-3",
                    "data-bs-toggle": "tooltip",
                    "data-bs-original-title": "Editar"
                  }, _hoisted_26, 8, _hoisted_24),
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: ($event: any) => (_ctx.deleteUnico(produto.id)),
                    "data-bs-toggle": "tooltip",
                    "data-bs-original-title": "Apagar"
                  }, _hoisted_29, 8, _hoisted_27)
                ])
              ]))
            }), 256))
          ])
        ])
      ])
    ])
  ]))
}